export const ELEMENT_IDEA_FLOW = 'idea-flow';
